import {getFormData, showFormErrors, submitFormDataViaAPI} from "../../utils/form";
import {handleCaptcha, initCaptcha, resetCaptcha} from '../../utils/captcha';
import {initCustomFieldsTagsInput, setCustomFieldsData} from "../../utils/custom_fields";
import {reportJobApplyEvent, reportProfessionalProfileRegisteredEvent} from "../../utils/analytics";
import Cookies from "js-cookie";
import $jsAPI from "../../front_end_api";
const initSkipRegwallButton = () => {
  $("#skip-apply-regwall, #skip-apply-regwall-mobile").click(() => {
    $jsAPI.fireEvent('job_seeker:reg_wall_completed', window.job, true);

    $("#skip-apply-regwall, #skip-apply-regwall-mobile").loading();

    Cookies.set('skip-regwall', true, {
      path: '/',
      expires: 30,
      secure: /https/.test(window.location.href)
    });

    location.href = $('#job-apply-link').val();
  });
};

const initRegistrationPageFields = () => {
  let formElement = null;
  if($("#apply-regwall").length) {
    formElement = $("#apply-regwall")
    initCaptcha(() => {
      registerViaRegwall();
    });
  } else if($("#form-register-job-seeker").length) {
    formElement = $("#form-register-job-seeker");
    initCaptcha(() => {
      register();
    });
  } else {
    return;
  }

  initCustomFieldsTagsInput()


  $("#submit-apply-regwall").click(handleCaptcha(
    (e) => {
      registerViaRegwall();

      return false;
    }
  ));

  $("#submit-usual-registration").click(handleCaptcha(
    (e) => {
      register();

      return false;
    }
  ));


  const register = async () => {
    let data = _getFormData();
     await submitFormDataViaAPI(data, formElement, (responseData) => {
      reportProfessionalProfileRegisteredEvent();
      $jsAPI.fireEvent('job_seeker:registered', responseData.user, responseData.job_seeker_profile);
    });

    resetCaptcha();
  }

  const registerViaRegwall = async () => {
    let data = _getFormData();
    let redirectUrl = $('#job-apply-link').val();

    $('#submit-apply-regwall').loading();

    try {
      await axios.post("/register/job-seeker", data);
      reportProfessionalProfileRegisteredEvent();

      $('#submit-apply-regwall').loading(false);
      $jsAPI.fireEvent('job_seeker:reg_wall_completed', window.job, false)
      location.href = redirectUrl;
    } catch (e) {
      console.log('error', e);

      $('#submit-apply-regwall').loading(false);

      showRegwallFormErrors(formElement, e.response);
    }

    resetCaptcha();
  };


  const showRegwallFormErrors = (formElement, response) => {
    showFormErrors(formElement, response);

    if (response.data && response.data.errors && (response.data.errors.file || response.data.errors.resume)) {
      $(".form-field-file-container").addClass('dz-container-error');
    } else {
      $(".form-field-file-container").removeClass('dz-container-error');
    }
  };

  const _getFormData = () => {
    let data = getFormData(formElement)

    if (data.custom_fields) {
      data.custom_fields = setCustomFieldsData(data.custom_fields, formElement.attr('id'));
    }

    return data;
  }
};

$(() => {
  initSkipRegwallButton();
  initRegistrationPageFields();
});
